import styled from "styled-components";
import { Select } from 'antd';

export const Container = styled("div")`
  display: inline-block;
  width: 100%;
  padding: 10px 5px;
`;

export const StyledSelect = styled("select")`
  height: 55px;
  width:100%;
  background-color:#e6e6e6;
  padding-left:10px;
  font-size: 12px;
  text-align:right;
`;
